<div class="flex pb-0 pt-[0px] overflow-hidden">
  <div class="w-[98%]">
    <div class="flex justify-between items-center pl-[20px]">
      <div class="flex space-x-10">
        <h1
          class="!text-[20px] pt-[10px] !m-0 !font-bold !text-[#21252A] Roboto"
        >
          USER ROLES MANAGER
        </h1>

        <button
          class="!text-[14px] font-bold !text-[#21252A] !pt-[30px] !h-[55px]"
          [class.active]="selectedTab === 'users'"
          (click)="selectTab('users')"
        >
          Users
        </button>
        <button
          class="!text-[14px] font-bold !text-[#21252A] !pt-[30px] !h-[55px]"
          [class.active]="selectedTab === 'roles'"
          (click)="selectTab('roles')"
        >
          Roles
        </button>
        <button
          class="!text-[14px] font-bold !text-[#21252A] !pt-[30px] !h-[55px]"
          [class.active]="selectedTab === 'permissions'"
          (click)="selectTab('permissions')"
        >
          Permissions
        </button>
      </div>
    </div>

    <div
      class="flex justify-between items-center border rounded-md 1h-[41px] !w-[70vw] mb-[14px] ml-[17px]"
    >
      <input
        type="text"
        placeholder="Search "
        class="p-2 outline-none w-[100%]"
      />
      <!--  (input)="onSearch($event)" -->
      <mat-icon class="mr-4 !text-[10px] cursor-pointer">search</mat-icon>
    </div>

    <div
      class="table-container mt-[0px]"
      style="
        max-height: calc(90vh - 170px);
        overflow-y: auto;
        border: 1px solid #ddd;
      "
    >
      <ng-container *ngIf="selectedTab === 'users'">
        <app-users
          [isDialogOpen]="isDialogOpen"
          [selectedTab]="selectedTab"
        ></app-users>
      </ng-container>

      <ng-container *ngIf="selectedTab === 'roles'">
        <app-roles
          [isDialogOpen]="isDialogOpen"
          [selectedTab]="selectedTab"
        ></app-roles>
      </ng-container>

      <ng-container *ngIf="selectedTab === 'permissions'">
        <app-permissions
          [isDialogOpen]="isDialogOpen"
          [selectedTab]="selectedTab"
        ></app-permissions>
      </ng-container>
    </div>
  </div>
  <ng-container *ngIf="selectedTab === 'users'">
    <div class="mt-[20px] flex !pt-0 p-[57px] !pb-0 mb-[0rem] justify-between">
      <button
        (click)="openDialog()"
        class="!bg-[#E76B3F] !text-[#ffffff] !text-[14px] flex h-[46px] justify-center items-center flex-shrink-0 hover:bg-white rounded-[3px] shadow-md ml-[15px] text-center"
        style="padding: 14px 24px; font-weight: 600"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_5810_47932)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 0C5.38125 0 0 5.38125 0 12C0 18.6187 5.38125 24 12 24C18.6187 24 24 18.6187 24 12C24 5.38125 18.6187 0 12 0Z"
              fill="#E76B3F"
            />
            <path
              d="M5.4375 13.107V10.8898C5.4375 10.6648 5.62031 10.4773 5.85 10.4773H10.4859V5.84609C10.4859 5.62109 10.6687 5.43359 10.8984 5.43359H13.1156C13.3406 5.43359 13.5234 5.61641 13.5234 5.84609V10.482H18.1547C18.3797 10.482 18.5672 10.6648 18.5672 10.8945V13.1117C18.5672 13.3367 18.3844 13.5195 18.1547 13.5195H13.5187V18.1508C13.5187 18.3758 13.3359 18.5633 13.1109 18.5633H10.8937C10.6687 18.5633 10.4813 18.3805 10.4813 18.1508V13.5148H5.85C5.62031 13.5195 5.4375 13.332 5.4375 13.107Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5810_47932">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Add New User
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="selectedTab === 'roles'">
    <div class="mt-[20px] flex !pt-0 p-[57px] !pb-0 mb-[0rem] justify-between">
      <button
        (click)="openDialog()"
        class="!bg-[#E76B3F] !text-[#ffffff] !text-[14px] flex h-[46px] justify-center items-center flex-shrink-0 hover:bg-white rounded-[3px] shadow-md ml-[15px] text-center"
        style="padding: 14px 24px; font-weight: 600"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_5810_47932)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 0C5.38125 0 0 5.38125 0 12C0 18.6187 5.38125 24 12 24C18.6187 24 24 18.6187 24 12C24 5.38125 18.6187 0 12 0Z"
              fill="#E76B3F"
            />
            <path
              d="M5.4375 13.107V10.8898C5.4375 10.6648 5.62031 10.4773 5.85 10.4773H10.4859V5.84609C10.4859 5.62109 10.6687 5.43359 10.8984 5.43359H13.1156C13.3406 5.43359 13.5234 5.61641 13.5234 5.84609V10.482H18.1547C18.3797 10.482 18.5672 10.6648 18.5672 10.8945V13.1117C18.5672 13.3367 18.3844 13.5195 18.1547 13.5195H13.5187V18.1508C13.5187 18.3758 13.3359 18.5633 13.1109 18.5633H10.8937C10.6687 18.5633 10.4813 18.3805 10.4813 18.1508V13.5148H5.85C5.62031 13.5195 5.4375 13.332 5.4375 13.107Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5810_47932">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Add New Role
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="selectedTab === 'permissions'">
    <!-- <div class="mt-[20px] flex !pt-0 p-[57px] !pb-0 mb-[0rem] justify-between">
      <button
        (click)="openDialog()"
        class=" !bg-[#E76B3F] !text-[#ffffff] !text-[14px] flex h-[46px] justify-center items-center flex-shrink-0 hover:bg-white rounded-[3px] shadow-md ml-[15px] text-center"
        style="padding: 14px 24px; font-weight: 600"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_5810_47932)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 0C5.38125 0 0 5.38125 0 12C0 18.6187 5.38125 24 12 24C18.6187 24 24 18.6187 24 12C24 5.38125 18.6187 0 12 0Z"
              fill="#E76B3F"
            />
            <path
              d="M5.4375 13.107V10.8898C5.4375 10.6648 5.62031 10.4773 5.85 10.4773H10.4859V5.84609C10.4859 5.62109 10.6687 5.43359 10.8984 5.43359H13.1156C13.3406 5.43359 13.5234 5.61641 13.5234 5.84609V10.482H18.1547C18.3797 10.482 18.5672 10.6648 18.5672 10.8945V13.1117C18.5672 13.3367 18.3844 13.5195 18.1547 13.5195H13.5187V18.1508C13.5187 18.3758 13.3359 18.5633 13.1109 18.5633H10.8937C10.6687 18.5633 10.4813 18.3805 10.4813 18.1508V13.5148H5.85C5.62031 13.5195 5.4375 13.332 5.4375 13.107Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5810_47932">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Add New Permission
      </button>
    </div> -->
    <div class="w-[20vw]"></div>
  </ng-container>
</div>
